module.exports = "/_next/static/images/bg-9c60498344da60899b5b55d18e377d27.svg";